import { html } from '@shared/utils/rendering/html';
import { useCachedFetch } from '../../../../utils/hooks/use-cached-fetch';
import { useEffect, useState } from 'preact/hooks';
import Table from '@shared/components/tables';
import {
    ComponentsPaginationConfig,
    ComponentsSortingConfig,
    ComponentsTableColumns,
} from '../../../../configs/tables/dashboard/components-table.config';
import { Filter } from '../../../../utils/helpers/static-filter/filter';

const Components = () => {
    const { data: components, isLoading } = useCachedFetch('/components');

    const [filteredData, setFilteredData] = useState([]);
    const [config, setConfig] = useState({
        columns: ComponentsTableColumns,
        filters: {
            sorting: {
                ...ComponentsSortingConfig,
                callback: (data) => onSortingUpdate(data),
            },
            pagination: {
                ...ComponentsPaginationConfig,
                paginationEvent: (data) => onPaginate(data),
                total: 0,
            },
        },
    });

    const onSortingUpdate = (data) => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            filters: {
                ...prevConfig.filters,
                sorting: {
                    ...prevConfig.filters.sorting,
                    sortByColumn: data.sortByColumn,
                    sortByDescending: data.sortByDescending,
                },
            },
        }));
    };

    const onPaginate = (data) => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            filters: {
                ...prevConfig.filters,
                pagination: {
                    ...prevConfig.filters.pagination,
                    paginationData: {
                        ...data,
                    },
                },
            },
        }));
    };

    useEffect(() => {
        filterComponents();
    }, [components, config]);

    const filterComponents = () => {
        setFilteredData(Filter(components, config));
    };

    return html`
        <${Table}
            config=${config}
            data=${{ rows: filteredData, total: components?.length, isLoading }}
        />
    `;
};

export default Components;
